<template>
  <div class="top-page">
    <!-- ヘッダー部分 -->
    <div class="header">
      <img src="@/assets/images/top/background_of_header_mobile.svg" alt="ヘッダー背景" class="header-background mobile-only">
      <img src="@/assets/images/top/background_of_header_desktop.svg" alt="ヘッダー背景" class="header-background desktop-only">
      <div class="app-intro">
        <h1>更年期症状の<br>傾向把握アプリ</h1>
        <p class="app-intro-text">新たなライフステージを<br>健やかに過ごせるように</p>
        <button class="download-btn" @click="redirectToAppStore">ダウンロード</button>
      </div>
      <div class="app-screenshot">
        <div class="screenshot-container">
          <img src="@/assets/images/top/screenshot_mobile.png" alt="アプリのスクリーンショット" class="screenshot-img mobile-only">
        </div>
        <div class="screenshot-container">
          <img src="@/assets/images/top/screenshot_desktop.svg" alt="アプリのスクリーンショット" class="screenshot-img desktop-only">
        </div>
      </div>
    </div>

    <!-- ドクター監修説明 -->
    <div class="doctor-intro">
      <h2>産婦人科医が監修した<br>更年期特化アプリ</h2>
      <p>メノアは産婦人科医が監修した更年期特化アプリです。更年期特有の症状や、症状が起こるきっかけ、生理日や経血量などを簡単に記録でき、それらを振り返って傾向を把握できます。</p>
      <p>更年期という新たなライフステージを迎える女性が、自分自身の変化を理解しながら、健やかに過ごせるようにサポートします。</p>
    </div>
    
    <img src="@/assets/images/top/wave_mobile.svg" alt="ウェーブ" class="wave-image mobile-only">
    <img src="@/assets/images/top/wave_desktop.svg" alt="ウェーブ" class="wave-image desktop-only">

    <!-- 機能紹介部分 -->
    <div class="features">
      <h2 class="features-title">メノアの特徴</h2>

      <div class="feature-item">
        <h3>症状のきっかけが分かる</h3>
        <p>症状が起こるときに、どのようなきっかけがあるのか分析できます。天候やストレスなどが症状に関連しているかどうか分かるので、日々の生活で何に気をつけるべきか分かるようになります。</p>
        <img src="@/assets/images/top/feature1_mobile.png" alt="機能5" class="feature-img mobile-only">
        <img src="@/assets/images/top/feature1_desktop.svg" alt="機能5" class="feature-img desktop-only">
      </div>

      <div class="feature-item">
        <h3>症状の傾向を把握できる</h3>
        <p>症状が続く日数や程度の変化、併せて起こりやすい症状など傾向を把握できます。傾向を知ることで、予定調整や心の準備もしやすくなります。</p>
        <img src="@/assets/images/top/feature2_mobile.png" alt="症状の傾向" class="feature-img mobile-only">
        <img src="@/assets/images/top/feature2_desktop.svg" alt="症状の傾向" class="feature-img desktop-only">
      </div>

      <div class="feature-item">
        <h3>生理周期との関連が分かる</h3>
        <p>気になる症状が、生理前後に起こりやすいのか分かります。</p>
        <img src="@/assets/images/top/feature3_mobile.png" alt="生理周期" class="feature-img mobile-only">
        <img src="@/assets/images/top/feature3_desktop.svg" alt="生理周期" class="feature-img desktop-only">
      </div>

      <div class="feature-item">
        <h3>生理の変化をチェックできる</h3>
        <p>生理周期や期間の日数、経血量の変化をチェックできます。</p>
        <img src="@/assets/images/top/feature4_mobile.png" alt="生理の変化" class="feature-img mobile-only">
        <img src="@/assets/images/top/feature4_desktop.svg" alt="生理の変化" class="feature-img desktop-only">
      </div>
      
      <div class="feature-item">
        <h3>かんたん記録</h3>
        <p>症状や、症状が起こるきっかけ、取り組み、メモなどを簡単に記録できます。</p>
        <img src="@/assets/images/top/feature5_mobile.png" alt="症状の記録" class="feature-img mobile-only">
        <img src="@/assets/images/top/feature5_desktop.svg" alt="症状の記録" class="feature-img desktop-only">
      </div>
      
    </div>

    <img src="@/assets/images/top/wave2_mobile.svg" alt="ウェーブ2" class="wave-image mobile-only">
    <img src="@/assets/images/top/wave2_desktop.svg" alt="ウェーブ2" class="wave-image desktop-only">

    <!-- 中間ダウンロードセクション -->
    <div class="mid-download-section">
      <p>健やかに過ごせるように<br>更年期症状の傾向を把握しましょう</p>
      <button class="download-btn" @click="redirectToAppStore">ダウンロード</button>
    </div>
    
    <img src="@/assets/images/top/wave_mobile.svg" alt="ウェーブ1" class="wave-image mobile-only">
    <img src="@/assets/images/top/wave_desktop.svg" alt="ウェーブ1" class="wave-image desktop-only">

    <!-- ドクター紹介部分 -->
    <div class="doctor-section">
      <h2>監修医師</h2>
      <div class="doctor-content">
        <img src="@/assets/images/top/doctor.jpg" alt="ドクター" class="doctor-img">
        <div class="doctor-info">
          <h3>高橋怜奈</h3>
          <p>山王ウィメンズ＆キッズクリニック院長。産婦人科専門医、指導医、女性ヘルスケア専門医、がん治療認定医、性教育認定講師。YouTubeやSNSで医療情報を発信している。</p>
        </div>
      </div>
    </div>

    <!-- ユーザーレビュー部分 -->
    <div class="reviews-section">
      <h2>仲間の声</h2>
      
      <div class="review-item">
        <div class="rating">
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
        </div>
        <p>他のアプリから乗り換えました。40代ちかくになってこれまで使ってた生理を記録するアプリが合わなくなってきたと感じていました。（もう妊娠とかもどうでもいいし…）いわゆる更年期の不調に戸惑うことも多くなったので、体調をきちんと管理できるアプリを探していたので、このアプリに乗り換えました。簡単に記録ができでて、不調や日々の生活を振り返ることができるので、不調の対策もしやすくなりました。デザインもカッコよくて気に入っています。</p>
      </div>

      <div class="review-item">
        <div class="rating">
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
        </div>
        <p>不調が生理周期と関係しているのか分かるのがとても助かります。以前は「なんとなく調子が悪い」と思っていましたが、記録を続けることでパターンが見えてきました。データを振り返ることで、体調管理の参考になりますし、心の準備もしやすいです。</p>
      </div>

      <div class="review-item">
        <div class="rating">
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
          <span class="star">★</span>
        </div>
        <p>とても使いやすく、簡単に記録できるので続けられています。特に、症状のきっかけや経血量まで記録できるのが便利で、体調の変化をより細かく把握できます。産婦人科医が監修しているので安心感もあります。</p>
      </div>
    </div>

    <img src="@/assets/images/top/wave2_mobile.svg" alt="ウェーブ2" class="wave-image mobile-only">
    <img src="@/assets/images/top/wave2_desktop.svg" alt="ウェーブ2" class="wave-image desktop-only">
    <!-- 中間ダウンロードセクション -->
    <div class="mid-download-section">
      <p>健やかに過ごせるように<br>更年期症状の傾向を把握しましょう</p>
      <button class="download-btn" @click="redirectToAppStore">ダウンロード</button>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'TOPView',
  data() {
    return {
      appStoreUrl: 'https://apps.apple.com/jp/app/id6736600712'
    }
  },
  mounted() {
    document.title = 'メノア | 更年期症状の傾向把握アプリ';
  },
  methods: {
    redirectToAppStore() {
      window.open(this.appStoreUrl, '_blank')
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - ページ全体の基本設定 */
.top-page {
  color: var(--color-text-primary);
  max-width: 100%;
  overflow-x: hidden;
}

/* 共通スタイル - ヘッダー部分 */
.header {
  display: flex;
  align-items: center;
  background-color: var(--color-green-200);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.header-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* 共通スタイル - 見出し */
h1, h2, h3 {
  color: var(--color-green-500);
}

h1 {
  line-height: 1.3;
  text-align: center;
}

h2 {
  text-align: center;
}

.features-title {
  text-align: left;
  margin-bottom: 2.5rem;
}

/* 共通スタイル - テキスト */
p {
  line-height: 1.5;
}

/* 共通スタイル - アプリ紹介部分 */
.app-intro {
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
}

.app-intro-text {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
}

/* 共通スタイル - ダウンロードボタン */
.download-btn {
  background-color: var(--color-yellow-500);
  color: var(--color-green-600);
  border: none;
  border-radius: 25px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

/* 共通スタイル - アプリスクリーンショット */
.app-screenshot {
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.screenshot-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.screenshot-background {
  position: absolute;
  width: 100%;
  height: auto;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  object-fit: cover;
}

.screenshot-img {
  position: relative;
  width: 100%;
  height: auto;
  z-index: 2;
  filter: drop-shadow(0 4px 8px rgba(35, 35, 35, 0.15));
}

/* 共通スタイル - 機能紹介部分 */
.features {
  padding: 2rem 1.5rem;
}

.feature-item {
  margin-bottom: 3rem;
}

.feature-img {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: block;
  margin-bottom: 2.5rem;
}

/* 共通スタイル - ドクター紹介部分 */
.doctor-section {
  background-color: white;
  padding: 2rem 1.5rem;
  text-align: left;
}

.doctor-section h2 {
  text-align: left;
}

.doctor-img {
  border-radius: 0;
  object-fit: cover;
}

/* 共通スタイル - ドクター監修説明 */
.doctor-intro {
  padding: 4rem 1.5rem;
  text-align: center;
  background-color: var(--color-green-200);
  margin-top: -2rem;
}

.doctor-intro h2 {
  margin-bottom: 1.5rem;
  text-align: left;
}

.doctor-intro p {
  margin-bottom: 1rem;
  text-align: left;
}

.doctor-intro p:last-child {
  margin-bottom: 3rem;
}

/* 共通スタイル - ウェーブ画像 */
.wave-image {
  width: 100%;
  display: block;
  margin-top: -2rem;
  margin-bottom: -2rem;
  z-index: 2;
  position: relative;
}

/* 共通スタイル - ユーザーレビュー部分 */
.reviews-section {
  padding: 2rem 1.5rem;
  background-color: white;
  padding-bottom: 4rem;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1;
}

.review-item {
  margin-bottom: 1.5rem;
  background-color: var(--color-green-200);
  padding: 1.5rem;
  border-radius: 12px;
}

.rating {
  margin-bottom: 0.5rem;
}

.rating span {
  font-size: 1.2rem;
  margin-right: 0.2rem;
  color: var(--color-yellow-500);
}

/* 共通スタイル - ダウンロードセクション */
.download-section {
  padding: 3rem 1.5rem;
  text-align: center;
  background-color: var(--color-bg-secondary);
}

.mid-download-section {
  padding: 3rem 1.5rem;
  text-align: center;
  background-color: var(--color-green-200);
}

/* モバイル専用スタイル */
/* モバイル専用スタイル - 表示切り替え制御 */
.mobile-only {
  display: block !important;
}

.desktop-only {
  display: none !important;
}

/* モバイル専用スタイル - ヘッダー */
.header {
  flex-direction: column;
  padding: 2rem 1.5rem;
}

.header-background.mobile-only {
  object-fit: fill; /* SVGを親要素のサイズに完全に合わせる */
  width: 154vw; /* 100vw / 0.65 = 約153.85vw（SVGの65%を画面幅に合わせる） */
  transform: translateX(-27vw); /* 左に27vw移動して中央に配置 */
}

/* モバイル専用スタイル - 見出し */
h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

h2 {
  font-size: 1.7rem;
  margin: 2rem 0;
}

h3 {
  font-size: 1.3rem;
  margin: 1rem 0;
}

/* モバイル専用スタイル - テキスト */
p {
  font-size: 1rem;
  margin-bottom: 1.5rem;
}

/* モバイル専用スタイル - ダウンロードボタン */
.download-btn {
  width: 131px;
  height: 41px;
  font-size: 14px;
}

/* モバイル専用スタイル - アプリスクリーンショット */
.app-screenshot {
  width: 100%;
  max-width: 300px;
}

/* モバイル専用スタイル - 機能紹介部分 */
.feature-item {
  text-align: left;
}

.feature-img {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: block;
  margin-bottom: 4.5rem;
}

/* モバイル専用スタイル - ドクター紹介部分 */
.doctor-section {
  text-align: left;
}

.doctor-img {
  width: 150px;
  height: 150px;
  margin-bottom: 0.5rem;
}

/* デスクトップ専用スタイル - タブレット以上 */
@media (min-width: 768px) {
  /* デスクトップ専用スタイル - 表示切り替え */
  .mobile-only {
    display: none !important;
  }

  .desktop-only {
    display: block !important;
  }

  /* デスクトップ専用スタイル - ヘッダー */
  .header {
    flex-direction: row;
    justify-content: space-between;
    padding: 4rem 5%;
    text-align: left;
  }
  
  /* デスクトップ専用スタイル - ヘッダー背景 */
  .header-background.desktop-only {
    width: 70%;
    height: 70%;
    object-fit: contain;
    right: 0;
    left: auto;
    top: 10%;
  }

  /* デスクトップ専用スタイル - アプリ紹介部分 */
  .app-intro {
    flex: 1;
    margin-right: 2rem;
    margin-bottom: 0;
    text-align: left;
    padding-left: 0;
  }

  /* デスクトップ専用スタイル - アプリ紹介内のダウンロードボタン */
  .app-intro .download-btn {
    margin: 0;
  }

  /* デスクトップ専用スタイル - アプリスクリーンショット */
  .app-screenshot {
    flex: 1;
    max-width: 360px;
  }

  /* デスクトップ専用スタイル - スクリーンショットコンテナ */
  .screenshot-container {
    width: 90%;
    margin-left: auto;
  }
  
  /* デスクトップ専用スタイル - スクリーンショット画像 */
  .screenshot-img.desktop-only {
    width: 85%;
    margin-left: auto;
  }

  /* デスクトップ専用スタイル - 見出し */
  h1 {
    font-size: 2.5rem;
    text-align: left;
  }

  /* デスクトップ専用スタイル - 改行を非表示 */
  .mid-download-section br {
    display: none;
  }

  /* デスクトップ専用スタイル - 機能紹介部分 */
  .features {
    padding: 3rem 0;
  }

  .features-title {
    margin-bottom: 4.5rem;
  }

  .feature-item {
    display: grid;
    grid-template-columns: 47.5% 47.5%;
    grid-column-gap: 5%;
    margin-bottom: -2rem; /* ネガティブマージンをより大きく設定 */
    position: relative; /* 子要素の絶対位置指定の基準点 */
  }

  /* 画像部分 */
  .feature-item .feature-img.desktop-only {
    grid-column: 1;
    width: 100%;
    max-width: 400px;
    margin: 0;
  }

  /* テキスト部分のコンテナ */
  .feature-item::after {
    content: "";
    grid-column: 2;
    display: block;
    padding-bottom: 100%; /* コンテナの高さを確保 */
  }

  /* テキスト部分の共通スタイル */
  .feature-item > h3,
  .feature-item > p {
    grid-column: 2;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  /* h3を絶対位置で配置 */
  .feature-item > h3 {
    position: absolute;
    top: 0;
    font-size: 1.5rem;
    line-height: 1.2;
  }

  /* デスクトップ専用スタイル - pをh3の直後に配置 */
  .feature-item > p {
    position: absolute;
    top: 3.5rem; /* h3の高さに合わせて調整 - 隙間を広げるために1.8remから2.5remに変更 */
    line-height: 1.5;
  }

  /* 画像部分 - 全て左側に配置 */
  .feature-item .feature-img.desktop-only {
    grid-column: 1;
    grid-row: 1 / span 2; /* テキスト2行分の高さを確保 */
    width: 100%;
    max-width: 400px;
    margin: 0 auto 0 0; /* 左寄せ */
  }
  
  /* 偶数番目の要素の設定を削除 - すべて同じレイアウトにする */
  /* 
  .feature-item:nth-child(even) > h3 {
    grid-column: 2;
  }
  
  .feature-item:nth-child(even) > p {
    grid-column: 2;
  }
  
  .feature-item:nth-child(even) .feature-img.desktop-only {
    grid-column: 1;
    margin: 0 auto 0 0;
  } */

  /* デスクトップ専用スタイル - ドクター紹介部分 */
  .doctor-section {
    padding: 4rem 0;
    text-align: left;
  }
  
  .doctor-content {
    display: flex;
    align-items: flex-start;
    margin-top: 1rem;
  }

  .doctor-img {
    width: 220px;
    height: auto;
    margin-right: 3rem;
    margin-bottom: 0;
  }

  .doctor-info {
    flex: 1;
  }
  
  .doctor-info h3 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  /* デスクトップ専用スタイル - ドクター監修説明のh2の改行を無効化 */
  .doctor-intro h2 br {
    display: none;
  }

  /* デスクトップ専用スタイル - レビュー項目を横並びに */
  .reviews-section {
    padding: 2rem 1.5rem;
    background-color: white;
    padding-bottom: 4rem;
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
  }
  
  /* reviews-sectionの背景を全幅に広げる */
  .reviews-section::before,
  .reviews-section::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100%;
    background-color: white;
    z-index: -1;
  }
  
  .reviews-section::before {
    right: 100%;
  }
  
  .reviews-section::after {
    left: 100%;
  }
  
  .reviews-section > * {
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .reviews-section .review-item {
    display: inline-block;
    width: 31%;
    margin-right: 1.25%;
    margin-left: 1.25%;
    vertical-align: top;
    padding: 2rem 1.4rem; /* 上下1.5rem、左右2remのパディング */
    height: 33rem; /* 全てのレビュー項目の高さを統一 - フォントサイズに対する相対値 */
  }
  
  .reviews-section .review-item:last-child {
    margin-right: 0;
  }
  
  .reviews-section > h2 {
    width: 100%;
    margin-bottom: 2.5rem;
  }
  
  .reviews-section > :not(h2) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

/* デスクトップ専用スタイル - 大画面 */
@media (min-width: 1024px) {
  /* デスクトップ専用スタイル - ヘッダー */
  .header {
    padding: 5rem 10% 5rem 0;
    max-width: 1080px;
    margin: 0 auto;
  }
  
  /* デスクトップ専用スタイル - ヘッダー背景（大画面） */
  .header-background.desktop-only {
    width: 80%;
    height: 80%;
    right: 0%;
    left: 25%;
    top: 10%;
  }
  
  /* デスクトップ専用スタイル - 他のセクション背景設定 */
  .features, .reviews-section {
    background-color: white;
    width: 100%;
    max-width: 100%;
  }
  
  /* デスクトップ専用スタイル - 各セクションの内側コンテンツのみ幅制限 */
  .features > *, .reviews-section > * {
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
  }

  /* デスクトップ専用スタイル - アプリスクリーンショット */
  .app-screenshot {
    max-width: 460px;
  }

  /* デスクトップ専用スタイル - スクリーンショットコンテナ（大画面） */
  .screenshot-container {
    width: 90%;
    margin-left: auto;
  }
  
  /* デスクトップ専用スタイル - スクリーンショット画像（大画面） */
  .screenshot-img.desktop-only {
    width: 85%;
    margin-left: auto;
  }

  /* デスクトップ専用スタイル - 見出し */
  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 2.2rem;
  }

  h3 {
    font-size: 1.5rem;
  }

  /* デスクトップ専用スタイル - テキスト */
  p {
    font-size: 1.1rem;
  }

  .app-intro-text {
    font-size: 1.25rem;
  }

  /* デスクトップ専用スタイル - 機能紹介部分 */
  .features {
    padding: 4rem 0;
  }
  
  .features-title {
    padding: 0;
  }
  
  .feature-item {
    padding: 0;
    margin-bottom: -2rem; /* 大画面ではさらに大きなネガティブマージンを設定 */
  }
  
  .feature-item .feature-img.desktop-only {
    max-width: 450px;
  }

  /* デスクトップ専用スタイル - ドクター紹介部分 */
  .doctor-section {
    padding: 5rem 0;
    max-width: 960px;
    margin: 0 auto;
    background-color: white;
  }
  
  .doctor-section h2 {
    padding: 0;
    margin-bottom: 1.2rem;
    font-size: 2.2rem;
  }
  
  .doctor-content {
    padding: 0;
  }
  
  /* doctor-sectionの背景を全幅に広げる */
  .doctor-section::before,
  .doctor-section::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100%;
    background-color: white;
    z-index: -1;
  }
  
  .doctor-section::before {
    right: 100%;
  }
  
  .doctor-section::after {
    left: 100%;
  }
  
  .doctor-section {
    position: relative;
    z-index: 1;
  }
  
  .doctor-img {
    width: 240px;
  }
  
  .doctor-info h3 {
    font-size: 1.7rem;
  }

  /* デスクトップ専用スタイル - ドクター監修説明 */
  .doctor-intro {
    padding: 4rem 0;
    max-width: 960px;
    margin: 0 auto;
  }

  .doctor-intro h2 {
    padding-left: 0;
    padding-right: 0;
  }
  
  .doctor-intro p {
    padding-left: 0;
    padding-right: 0;
  }

  /* デスクトップ専用スタイル - ユーザーレビュー部分 */
  .reviews-section {
    padding: 4rem 0;
    max-width: 960px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .reviews-section > * {
    padding: 0;
  }

  /* デスクトップ専用スタイル - ダウンロードセクション */
  .download-section {
    padding: 5rem 10%;
    max-width: 960px;
    margin: 0 auto;
  }
  
  .mid-download-section {
    padding: 5rem 10%;
    max-width: 960px;
    margin: 0 auto;
  }
  
  /* デスクトップ専用スタイル - ダウンロードボタン */
  .download-btn {
    width: 143px;
    height: 43px;
  }

  /* デスクトップ専用スタイル - ヘッダー背景拡張 */
  .top-page {
    background-color: var(--color-green-200);
  }

  /* デスクトップ専用スタイル - 機能紹介部分 */
  .features {
    padding: 4rem 0;
  }
  
  .features-title {
    padding: 0;
  }
  
  .feature-item {
    padding: 0;
    margin-bottom: -2rem; /* 重複しているセレクタでも同じ値を設定 */
  }
  
  .feature-item .feature-img.desktop-only {
    max-width: 450px;
  }
  
  /* 位置調整不要 - グリッドで制御 */
  /* .feature-item:nth-child(odd) > h3,
  .feature-item:nth-child(odd) > p {
    left: 10%;
  }
  
  .feature-item:nth-child(even) > h3,
  .feature-item:nth-child(even) > p {
    right: 10%;
  } */
}

.reviews-section h2 {
  text-align: left;
}
</style>